import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Banner from '../components/Banner'

const InvestorInformation = props => (
  <div>
    <Helmet>
      <title>Sonder Definition</title>
      <meta name="description" content="Sonder Definition" />
    </Helmet>

    <Banner
      title={'Investor Information'}
      subTitle={'If you want to change the future of social, join us.'}
    />

    <div id="main">
      <section id="one">
        <div className="inner">
          <p>Sonder is not actively raising funding.</p>
          <p>&nbsp;</p>
          <p>
            If you are interested in seeing our pitch deck, receiving our weekly
            update email, or joining the beta version of the app, please contact
            Connor at connor.mullins@sonder.social
          </p>
        </div>
      </section>
    </div>
  </div>
)

export default InvestorInformation



// WEBPACK FOOTER //
// ./src/pages/investorInfo.js